export default "__VITE_ASSET__VzCd9ojK__"